import { Module } from "wrapper6";
import Glide from '@glidejs/glide';
import { toggleClass, hasClass, removeClass, addClass } from "../utils/_class-handlers";

var $ = jQuery;

export default class ModuleSlider extends Module {

	ready(app) {
        
        const SLIDER_CONTAINERS = document.querySelectorAll('.mtt-course-modules');

        if (SLIDER_CONTAINERS.length > 0) {

            for (let i = 0; i < SLIDER_CONTAINERS.length; i++) {

                const SLIDER_CONTAINER = SLIDER_CONTAINERS[i];
                const GLIDE = SLIDER_CONTAINER.querySelector('.glide');

                if (GLIDE) {

                    const COUNT = SLIDER_CONTAINER.querySelectorAll('.module').length;
                    const ARROW_LEFT = SLIDER_CONTAINER.querySelector('.modules-arrows .arrow.left');
                    const ARROW_RIGHT = SLIDER_CONTAINER.querySelector('.modules-arrows .arrow.right');
                    
                    // setup slider
                    const SLIDER = new Glide(GLIDE, {
                        type: 'slider',
                        startAt: 0,
                        perView: 3,
                        gap: 180,
                        animationDuration: 800,
                        rewind: false,
                        breakpoints: {
                            1800: {
                                gap: 140,
                                perView: 2,
                                peek: {
                                    before: 0,
                                    after: 450
                                }
                            },
                            1650: {
                                gap: 180,
                                perView: 2,
                                peek: {
                                    before: 0,
                                    after: 0
                                }
                            },
                            1280: {
                                gap: 140,
                                perView: 2,
                                peek: {
                                    before: 0,
                                    after: 0
                                }
                            },
                            1050: {
                                gap: 140,
                                perView: 1,
                                peek: {
                                    before: 0,
                                    after: 350
                                }
                            },
                            850: {
                                gap: 100,
                                perView: 1,
                                peek: {
                                    before: 0,
                                    after: 250
                                }
                            },
                            650: {
                                gap: 40,
                                perView: 1,
                                peek: {
                                    before: 0,
                                    after: 0
                                }
                            },
                        }
                    });
    
                    // Mount slider
                    SLIDER.mount();

                    // Arrows
                    if (ARROW_LEFT) ARROW_LEFT.addEventListener('click', () => SLIDER.go('<'));
                    if (ARROW_RIGHT) ARROW_RIGHT.addEventListener('click', () => SLIDER.go('>'));

                    // Arrow classes
                    SLIDER.on('run', () => { this.arrowClassHandler(ARROW_LEFT, ARROW_RIGHT, SLIDER, COUNT); });
                    window.addEventListener('resize', () => { this.arrowClassHandler(ARROW_LEFT, ARROW_RIGHT, SLIDER, COUNT); });
                }
            }
        }
    }

    arrowClassHandler(ARROW_LEFT, ARROW_RIGHT, SLIDER, COUNT) {

        if (!ARROW_LEFT && !ARROW_RIGHT)
            return;

        if (SLIDER._i === 0) {
            addClass(ARROW_LEFT, 'hide');
            removeClass(ARROW_RIGHT, 'hide');
        } else if (SLIDER._i + 2 >= COUNT && this.getWindowWidth() > 1050) {
            removeClass(ARROW_LEFT, 'hide');
            addClass(ARROW_RIGHT, 'hide');
        } else if (SLIDER._i + 1 >= COUNT && this.getWindowWidth() <= 1050) {
            removeClass(ARROW_LEFT, 'hide');
            addClass(ARROW_RIGHT, 'hide');
        } else {
            removeClass(ARROW_LEFT, 'hide');
            removeClass(ARROW_RIGHT, 'hide');
        }
    }

    getWindowWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
}